var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PillBadge',{class:['year-pill', _vm.isCurrentYear && 'year-pill--current-year'],attrs:{"sober":"","straighten-corner":_vm.straightenCorner}},[_vm._v("\n  "+_vm._s(_vm.year)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }